import React from 'react';
import styled from 'styled-components';
import HamburgerSvg from 'src/app.feature/academy/component/icon/hamburger-icon.svg';

const CategoryButton = ({ handleClickParentCategory, name, id }: any) => {
  return (
    <StyledWrapper onClick={() => handleClickParentCategory(id)}>
      <HamburgerSvg />
      {name}
    </StyledWrapper>
  );
};

export default CategoryButton;

const StyledWrapper = styled.button`
  min-width: 140px;
  padding: 0px 33px;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  svg {
    margin-right: 16px;
  }
`;
